import { render, staticRenderFns } from "./ClearSetting.vue?vue&type=template&id=2b3810e9&"
import script from "./ClearSetting.vue?vue&type=script&lang=ts&"
export * from "./ClearSetting.vue?vue&type=script&lang=ts&"
import style0 from "./ClearSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClearSetting.vue"
export default component.exports